import React from "react"
import { useCallback } from "react"
import "./navigator-steps.scss"

/**
 *
 * @param {number} step current step active
 * @param {number} [stepsLenght=5] steps lenght, *__default 5__*
 */
const NavigatorSteps = ({ step, stepsLenght = 5 }) => {
  const renderSteps = useCallback(() => {
    let stepElements = []
    for (let currentStep = 1; currentStep <= stepsLenght; currentStep++) {
      stepElements.push(
        <div
          key={`step-${currentStep}`}
          className={
            step >= currentStep
              ? step === currentStep
                ? "f-navigator-steps-step f-navigator-steps-step-selected"
                : "f-navigator-steps-step f-navigator-steps-step-active"
              : "f-navigator-steps-step"
          }
        >
          <span className="f-navigator-step__content">{currentStep}</span>
        </div>
      )
    }
    return stepElements
  }, [step, stepsLenght])

  return <div className="f-navigator-steps">{renderSteps().map(i => i)} </div>
}

export default NavigatorSteps
